import { create } from 'zustand'
import { contractReducer, createInitialState } from '../engine/contractReducer'
import type { ContractGameState, ContractGameAction } from '../engine/types'

type ContractGameStoreState = ContractGameState & {
  activeClauseId: string | null
  setActiveClauseId: (id: string | null) => void
  dispatch: (action: ContractGameAction) => void
  reset: () => void
}

export const useContractGameStore = create<ContractGameStoreState>((set) => ({
  ...createInitialState(),
  activeClauseId: null,
  setActiveClauseId: (id) => set({ activeClauseId: id }),
  dispatch: (action) =>
    set((store) => contractReducer(store, action)),
  reset: () => set({ ...createInitialState(), activeClauseId: null }),
}))

